import { lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AiChatBox } from "@/components/report/AiChatBox/AiChatBox";

// CUSTOMER - SALES & ORDERS
const SalesQuotes = lazy(
  () => import("../components/customers/quote/QuoteList")
);

const SalesOrders = lazy(
  () => import("../components/customers/sales/SalesOrder")
);
const So = lazy(() => import("../components/customers/sales/so/So"));
const DispatchMergeList = lazy(
  () => import("../components/customers/sales/so/merge/DispatchMergeList")
);
const CreditPo = lazy(() => import("../components/creditPo/CreditPo"));
const PickWorkflowList = lazy(
  () => import("../components/customers/sales/so/pickWorkflow/PickWorkflowList")
);
const ActivePckList = lazy(
  () => import("../components/customers/sales/so/pickWorkflow/ActivePckList")
);

const SchedulePckModal = lazy(
  () => import("../components/customers/sales/so/pickWorkflow/SchedulePckModal")
);

const AddItem = lazy(
  () =>
    import(
      "../components/customers/sales/so/soTableDetails/modals/addItem/AddItem"
    )
);

const CreatePackModal = lazy(
  () =>
    import(
      "../components/customers/sales/so/packing/createPack/CreatePackModal"
    )
);

// INVENTORY & ITEMS
const ItemList = lazy(() => import("../components/itemList/ItemList"));
const NewItem = lazy(() => import("../components/itemList/NewItem"));
const Inventory3DTable = lazy(
  () => import("../components/sharedComponent/Inventory3d")
);

const AsmWorkOrder = lazy(() => import("../components/inventory/AsmWorkOrder"));
const AsmWorkOrderList = lazy(
  () => import("../components/inventory/AsmWorkOrderList")
);
const ProductAssembly = lazy(
  () => import("../components/inventory/ProductAssembly")
);

// WAREHOUSES & TRANSFERS
const WarehousesList = lazy(
  () => import("../components/warehouses/WarehousesList")
);
const TransferList = lazy(() => import("../components/transfer/TransferList"));
const Trn = lazy(() => import("../components/transfer/Trn"));
const BinLocations = lazy(
  () => import("../components/warehouses/BinLocations")
);

// CONTACTS
const Contacts = lazy(() => import("../components/contactPage/Contacts"));
const NewContact = lazy(() => import("../components/contactPage/NewContact"));
const ContactDetails = lazy(
  () => import("../components/contactPage/contactDetails/ContactDetails")
);
const ContactTagsList = lazy(
  () => import("../components/contact/ContactTagsList")
);

// UNASSIGNED PACKS
const UnassignedPacks = lazy(
  () => import("../components/unassignedPacks/UnassignedPacks")
);

// REPORTS
const Report = lazy(() => import("../components/report/Report"));
const Schedules = lazy(() => import("../components/report/Schedules"));
const AdministrationReports = lazy(
  () => import("../components/administration/reports")
);
const ReportDocuments = lazy(
  () => import("../components/administration/reports/ReportDocuments")
);
const ScheduleReport = lazy(
  () => import("../components/report/schedule/ScheduleReport")
);

// DOCUMENTS & DATA

const DataExport = lazy(() => import("../components/dataExports/DataExport"));
const DataExportUser = lazy(
  () => import("../components/dataExports/DataExportUser")
);
const EmailInvoice = lazy(
  () => import("../components/emailInvoice/EmailInvoice")
);
const MatchDocuments = lazy(
  () => import("../components/matchDocuments/MatchDocuments")
);
const SendEmail = lazy(() => import("../components/sharedComponent/SendEmail"));
const DocumentSettings = lazy(
  () => import("../components/administration/documents")
);

// ADMINISTRATION - SETTINGS
const AdministrationSettings = lazy(
  () => import("../components/administration/settings")
);
const Users = lazy(() => import("../components/administration/users/index"));

// SETTINGS - INVENTORY ADMINISTRATION
const GlobalModal = lazy(() => import("../components/globalModal/Index"));
const TokenGenerator = lazy(() => import("../components/TokenGenerator"));

const PipelineList = lazy(
  () => import("../components/administration/documents/pipeline/Pipeline")
);
const MonitorList = lazy(
  () => import("../components/administration/documents/monitor/MonitorList")
);
const CustomFields = lazy(
  () =>
    import("../components/administration/documents/customField/CustomFieldList")
);
const DocumentTags = lazy(
  () =>
    import(
      "../components/administration/documents/documentTags/DocumentTagsList"
    )
);
const EmailTemplates = lazy(
  () =>
    import(
      "../components/administration/documents/emailTemplate/EmailTemplates"
    )
);
const ItemTemplates = lazy(
  () =>
    import(
      "../components/administration/documents/itemTemplates/ItemTemplateList"
    )
);
const DocumentStages = lazy(
  () =>
    import(
      "../components/administration/documents/documentStage/DocumentStageList"
    )
);
const HeadersSequences = lazy(
  () =>
    import(
      "../components/administration/documents/headers&Sequences/HeaderSequencesList"
    )
);

// ADMINISTRATION - SETTINGS
const InventoryAdministration = lazy(
  () => import("../components/inventoryAdministration")
);

// SETTINGS - INTEGRATIONS
const Integrations = lazy(
  () => import("../components/administration/settings/integrations")
);
const AppsList = lazy(
  () =>
    import("../components/administration/settings/integrations/apps/AppsList")
);
const CarriersList = lazy(
  () =>
    import(
      "../components/administration/settings/integrations/carrier/CarriersList"
    )
);
const MarketplacesList = lazy(
  () =>
    import(
      "../components/administration/settings/integrations/marketplaces/MarketplacesList"
    )
);
const MarketplacesListings = lazy(
  () =>
    import(
      "../components/administration/settings/integrations/marketplaces/listings/Listings"
    )
);
const AppIntegration = lazy(
  () => import("../components/administration/appIntegration/AppIntegration")
);
const ThreePLModal = lazy(
  () =>
    import("../components/administration/appIntegration/ThreePL/ThreePLModal")
);
const SellerFlexDashboard = lazy(
  () =>
    import(
      "../components/administration/appIntegration/sellerFlex/SellerFlexDashboard"
    )
);

// SETTINGS - GENERAL
const Smtp = lazy(
  () => import("../components/administration/settings/smtp/Smtp")
);
const Taxes = lazy(
  () => import("../components/administration/settings/taxes/Taxes")
);
const TaxGroupModal = lazy(
  () => import("../components/administration/settings/taxes/TaxGroupModal")
);
const Currencies = lazy(
  () => import("../components/administration/settings/currency/Currencies")
);
const EmailOutbox = lazy(
  () => import("../components/administration/settings/emailOutbox/EmailOutbox")
);
const CustomerPortalList = lazy(
  () =>
    import("../components/administration/settings/portal/CustomerPortalList")
);

const PrintLabel = lazy(() => import("../components/globalModal/print/Print"));

// FBA
const FbaHomepage = lazy(
  () => import("../components/fba-inbound/homepage/FbaHomepage")
);
const PlansList = lazy(
  () => import("../components/fba-inbound/planList/PlansList")
);

const PlanDetailV3 = lazy(
  () => import("../components/fba-inbound/planList/PlanDetailV3")
);

// Error & System
const PageNotFound = lazy(
  () => import("../components/sharedComponent/PageNotFound")
);

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<GlobalModal />}>
        {/* SALES & ORDERS */}
        <Route path="/sales-quote" element={<SalesQuotes />} />
        <Route path="/sales" element={<SalesOrders />} />
        <Route path="/so/doc/:docId" element={<So />} />
        <Route path="/credit-po" element={<CreditPo />} />
        <Route path="/pick-workflow" element={<PickWorkflowList />} />
        <Route path="/active-pck" element={<ActivePckList />} />
        <Route path="/active-pck-upsert" element={<SchedulePckModal />} />
        <Route
          path="/addItem/:docType/:docId"
          element={<AddItem color="sky" handleClose={() => {}} />}
        />
        <Route
          path="/create-pack/:baseType/:baseId"
          element={<CreatePackModal />}
        />
        <Route path="/so/doc/:docId" element={<So />} />
        <Route path="/dispatch-merge" element={<DispatchMergeList />} />
        {/* INVENTORY & ITEMS */}
        <Route path="/item-list" element={<ItemList />} />
        <Route path="/new-item/:itemType" element={<NewItem />} />
        <Route path="/inventory3d/:itemSku" element={<Inventory3DTable />} />
        <Route path="/asm/wo" element={<AsmWorkOrderList />} />
        <Route path="/asm/wo/:id" element={<AsmWorkOrder />} />
        <Route path="/asm/create" element={<ProductAssembly />} />

        {/* WAREHOUSES & TRANSFERS */}
        <Route path="/warehouses" element={<WarehousesList />} />
        <Route path="/trn" element={<TransferList />} />
        <Route path="/trn/:trnId" element={<Trn />} />
        <Route
          path="/warehouses/:warehouseId/bin-locations"
          element={<BinLocations />}
        />

        {/* CONTACTS */}
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/new-contact" element={<NewContact />} />
        <Route path="/contacts/:contactId" element={<ContactDetails />} />
        <Route path="/contacts/tags-list" element={<ContactTagsList />} />

        {/* UNASSIGNED PACKS */}
        <Route path="/shp/unassigned-packs" element={<UnassignedPacks />} />

        {/* REPORTS */}
        <Route path="/reports/schedules" element={<Schedules />} />
        <Route path="/reports/:reportType" element={<Report />} />
        <Route
          path="/administration/report"
          element={<AdministrationReports />}
        />
        <Route
          path="/administration/report/document"
          element={<ReportDocuments />}
        />
        <Route
          path="/administration/report/schedule-report/:scheduleId"
          element={<ScheduleReport />}
        />

        {/* DOCUMENTS & DATA */}
        <Route path="/documents/data-export" element={<DataExport />} />
        <Route
          path="/documents/data-export-user"
          element={<DataExportUser />}
        />
        <Route path="/email-invoice" element={<EmailInvoice />} />
        <Route path="/match-documents" element={<MatchDocuments />} />
        <Route
          path="/match-documents/:documentId"
          element={<MatchDocuments />}
        />
        <Route path="/send-email" element={<SendEmail />} />

        {/* ADMINISTRATION - DOCUMENTS */}
        <Route
          path="/administration/documents"
          element={<DocumentSettings />}
        />
        <Route
          path="/administration/documents/:section"
          element={<DocumentSettings />}
        />

        {/* ADMINISTRATION - SETTINGS */}
        <Route
          path="/administration/settings"
          element={<AdministrationSettings />}
        />
        <Route
          path="/administration/settings/:section"
          element={<AdministrationSettings />}
        />
        <Route path="/administration/user" element={<Users />} />

        {/* SETTINGS - INVENTORY ADMINISTRATION */}
        <Route
          path="/settings/inventory-administration"
          element={<InventoryAdministration />}
        />
        <Route
          path="/settings/inventory-administration/:section"
          element={<InventoryAdministration />}
        />
        <Route
          path="/settings/inventory-administration/:section/import/:catalogueImportId"
          element={<InventoryAdministration />}
        />
        <Route
          path="/settings/inventory-administration/item-views/import/:itemViewImportId"
          element={<InventoryAdministration />}
        />
        <Route
          path="/settings/inventory-administration/:section/import/:itemViewImportId/:importType"
          element={<InventoryAdministration />}
        />

        {/* SETTINGS - APP INTEGRATIONS */}
        <Route
          path="/settings/app-integration/3pl"
          element={<ThreePLModal />}
        />
        <Route
          path="/settings/app-integration/seller-flex/dashboard/:appId"
          element={<SellerFlexDashboard />}
        />
        <Route
          path="/settings/app-integration/:appTypeId"
          element={<AppIntegration />}
        />
        <Route
          path="/settings/app-integration/:appTypeId/:appId"
          element={<AppIntegration />}
        />

        {/* SETTINGS - INTEGRATIONS */}
        <Route path="/settings/integrations" element={<Integrations />} />
        <Route
          path="/settings/integrations/carrier"
          element={<CarriersList />}
        />
        <Route path="/settings/integrations/apps" element={<AppsList />} />
        <Route
          path="/settings/integrations/marketplaces"
          element={<MarketplacesList />}
        />
        <Route
          path="/marketplace/listings/:marketplaceId"
          element={<MarketplacesListings />}
        />

        {/* FBA */}
        <Route path="/fba-inbound" element={<FbaHomepage />} />
        <Route path="/fba-inbound/plans" element={<PlansList />} />
        <Route path="/fba-inbound/new-transfer-v3" element={<PlanDetailV3 />} />
        <Route path="/fba-inbound/plan" element={<PlanDetailV3 />} />
        <Route
          path="/fba-inbound/plans/:mpIdParam/:planIdParam/:stage"
          element={<PlanDetailV3 />}
        />

        {/* SETTINGS - GENERAL */}
        <Route path="/settings/monitor-iframe" element={<MonitorList />} />
        <Route path="/settings/pipeline-iframe" element={<PipelineList />} />
        <Route path="/settings/item-templates" element={<ItemTemplates />} />
        <Route path="/settings/document-tags" element={<DocumentTags />} />
        <Route
          path="/settings/custom-fields"
          element={
            <div className="lg:pr-2">
              <CustomFields />
            </div>
          }
        />
        <Route
          path="/settings/customer-portals"
          element={<CustomerPortalList />}
        />
        <Route
          path="/settings/headers-sequences"
          element={<HeadersSequences />}
        />
        <Route path="/settings/document-stages" element={<DocumentStages />} />
        <Route
          path="/settings/email-template-iframe"
          element={<EmailTemplates />}
        />
        <Route path="/settings/taxes" element={<Taxes />} />
        <Route path="/settings/taxes/upsert" element={<TaxGroupModal />} />
        <Route
          path="/settings/taxes/upsert/:taxId"
          element={<TaxGroupModal />}
        />
        <Route path="/settings/currencies" element={<Currencies />} />
        <Route path="/settings/smtp" element={<Smtp />} />
        <Route path="/settings/email-outbox" element={<EmailOutbox />} />
        <Route path="/token-generator" element={<TokenGenerator />} />
        <Route
          path="/print-label/:documentType/:documentId"
          element={<PrintLabel />}
        />

        <Route path="/AI" element={<AiChatBox />} />
        {/* SYSTEM & UTILITIES */}
        <Route path="/health" element={<div>Healthy</div>} />
      </Route>
      <Route path="/404" element={<PageNotFound />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
